// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3IayR","footer":"ModalCreateQualiphyProcedure_footer__2UkCp","additionData":"ModalCreateQualiphyProcedure_additionData__1b8Bh"};